import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export interface HistoryPointsViewProps {
  points: string;
}

export const HistoryPointsView = ({ points }: HistoryPointsViewProps) => (
  <div className="md:flex">
    <div className="w-1/4">
      <Typography.LabelSm weight="semibold">
        {t("settings.workflows.action_messages.award_points.points")}
      </Typography.LabelSm>
    </div>
    <div className="w-3/4">
      <Typography.LabelSm weight="semibold">{points}</Typography.LabelSm>
    </div>
  </div>
);
